// Extrait le texte affichable + les URLs d'images BD d'un message de conversation.
//
// Les images peuvent provenir de deux endroits :
//  - un bloc `tool_result` (boucle agent : génération normale),
//  - un bloc `text` (planche postée HORS agent : régénération / édition de
//    bulles en tâche de fond — cf. append_assistant_message côté backend).
// Dans le cas texte, on RETIRE l'URL du texte affiché (sinon elle s'affiche en
// clair sous le message).

const IMG_RE = /\/api\/bd\/chapters\/[^\s'"]+\/image/g;
const IMAGE_CHAPTER_RE = /\/api\/bd\/chapters\/[^/]+-(\d+)\/versions\//;

export function chapterIndexFromImageUrl(url) {
  const m = typeof url === "string" ? url.match(IMAGE_CHAPTER_RE) : null;
  return m ? Number(m[1]) : null;
}

export function extractTextAndImagesFromMessage(msg) {
  const out = { text: "", imageUrls: [] };
  if (!msg || !Array.isArray(msg.content)) return out;
  for (const b of msg.content) {
    if (b.type === "text" && typeof b.text === "string") {
      const urls = b.text.match(IMG_RE) || [];
      out.imageUrls.push(...urls);
      let cleaned = b.text;
      for (const u of urls) cleaned = cleaned.split(u).join("");
      cleaned = cleaned.trim();
      if (cleaned) out.text += (out.text ? "\n" : "") + cleaned;
    }
    if (b.type === "tool_result") {
      const inner = Array.isArray(b.content) ? b.content : [];
      for (const ib of inner) {
        if (ib.type === "text" && typeof ib.text === "string") {
          const matches = ib.text.match(IMG_RE) || [];
          out.imageUrls.push(...matches);
        }
      }
    }
  }
  return out;
}
